import { GRAMMAR_CHECKPOINT_SIZE } from '@repo/config';
import { z } from 'zod';
import { grammarSubmittedAnswerSchema } from '../schemas';

const grammarCheckpointAnswerSchema = z.object({
  itemId: z.number().int().positive(),
  response: grammarSubmittedAnswerSchema,
});

const submitGrammarCheckpointV1RequestSchemaDefinition = z.object({
  token: z.string().min(1),
  answers: z
    .array(grammarCheckpointAnswerSchema)
    .min(1)
    .max(GRAMMAR_CHECKPOINT_SIZE)
    .refine(
      (answers) => new Set(answers.map(({ itemId }) => itemId)).size === answers.length,
      'Checkpoint answers must reference distinct items',
    ),
  durationMs: z.number().int().min(0),
  timezone: z.string().optional(),
});

export const submitGrammarCheckpointV1RequestSchema: typeof submitGrammarCheckpointV1RequestSchemaDefinition =
  submitGrammarCheckpointV1RequestSchemaDefinition;

export type ISubmitGrammarCheckpointV1Request = z.infer<
  typeof submitGrammarCheckpointV1RequestSchema
>;

export type IGrammarCheckpointAnswer = ISubmitGrammarCheckpointV1Request['answers'][number];
